import { auth } from "apis";


export const createHotspot = async (data) => {
    const options = {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage?.getItem("adminSession") || ""}`,
        }
    }
    const res = await auth({
        method: "POST",
        url: `/admin/hotspot`,
        options,
        data
    });
    return res;
};

export const getHotspotByStatus = async (page,status) => {
    const res = await auth({
        method: 'GET',
        url: `/admin/hotspot?page=${page}&limit=10&status=${status}`,
    })
    return res
}

export const updateHotspot = async (data) => {
    const options = {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage?.getItem("adminSession") || ""}`,
        }
    }
    const res = await auth({
        method: 'PUT',
        url: `/admin/hotspot`,
        options,
        data,
    })
    return res
}

export const getHotspotById = async (id) => {
    const res = await auth({
        method: 'GET',
        url: `/admin/hotspot/${id}`,
    })
    return res
}

export const updateHotspotStatus = async (id,data) => {
    const res = await auth({
        method: 'PUT',
        url: `/admin/hotspot/status/${id}`,
        data
    })
    return res
}